import React from 'react';
import { Alert, Spin } from '@nackle/origami';

const Fallback = ( { errorDisplay, loaderColor } ) => {
    return (
        <React.Fragment>
            {
                !errorDisplay && loaderColor &&
                    <Spin className="main-spin" size={ 'medium' } spinning={ true } />
            }
            { errorDisplay &&
                <Alert className="module-error" message={ 'Module load error!' } type="error" closable={ true }/>
            }
        </React.Fragment>
    );
};

export default Fallback;
